// 쿠팡 로켓그로스 입고자료 자동 채움(2026-10-06 YZY) — 入库列表 「쿠팡 입고자료」 창이 쓴다.
//  ① 윙 「입고요청 엑셀」(시트 「로켓그로스 입고」) → `입고 수량 입력(필수)` 열을 박스 바코드별 수량 합으로 채운다
//  ② 윙 「Milkrun_Configuration_<번호>_<날짜>.xlsx」(파일명 숫자는 입고ID 가 아니다 — YZY 정정) → 박스 총 수량·총 중량·박스별 사이즈·박스별 수량을 채운다
// 원본 양식(서식·병합·데이터 유효성·메모·시트 보호·다른 시트)을 그대로 두려고 SheetJS 로 다시 쓰지 않는다.
// xlsx 압축을 XLSX.CFB 로 열어 해당 칸의 XML 만 고쳐 다시 묶는다 — 값을 읽을 때만 XLSX.read 를 쓴다.
import * as XLSX from 'xlsx';

const CFB = XLSX.CFB;
const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// 箱子大小(Labels.박스크기, BoxAssignModal BOX_SIZE_OPTIONS) → 밀크런 박스 사이즈(2026-10-06 YZY)
export const COUPANG_BOX_SIZE = {
  '1号大箱(特)': '사이즈 3호',
  '1号大箱(纸皮)': '사이즈 3호',
  '1号大箱': '사이즈 3호',
  '2号箱': '사이즈 2호',
  '3号小箱': '사이즈 1호'
};
export function coupangBoxSize(v) {
  const s = String(v || '').trim();
  if (COUPANG_BOX_SIZE[s]) return COUPANG_BOX_SIZE[s];
  if (/^1号/.test(s)) return '사이즈 3호';
  if (/^2号/.test(s)) return '사이즈 2호';
  if (/^3号/.test(s)) return '사이즈 1호';
  return '';
}
// 총 중량 = 20kg × 박스수 − 1 (2026-10-06 YZY. 양식 검사식이 「총 중량 < 박스수 × 20」 이다)
export function milkrunWeight(boxCount) {
  return boxCount > 0 ? boxCount * 20 - 1 : 0;
}
// 파일명 앞 판매자코드(A00753948_20261006.xlsx → A00753948)
export function supplierCodeFromName(name) {
  const m = String(name || '').match(/^([A-Z]\d{5,})_/);
  return m ? m[1] : '';
}
export function normBarcode(v) {
  return String(v == null ? '' : v).trim().toUpperCase();
}
// 箱号 Z-lumin\nFK1004002 같은 값을 숫자까지 자연 정렬
export function compareLabelId(a, b) {
  return String(a).localeCompare(String(b), undefined, { numeric: true });
}

// ---------- xlsx 압축 안 XML 다루기 ----------
const enc = s => new TextEncoder().encode(s);
const dec = b => new TextDecoder('utf-8').decode(b);
function openZip(buf) {
  const data = buf instanceof Uint8Array ? buf : new Uint8Array(buf);
  return { cfb: CFB.read(data, { type: 'array' }), wb: XLSX.read(data, { type: 'array' }) };
}
function getXml(cfb, path) {
  const e = CFB.find(cfb, path);
  return e ? dec(e.content) : null;
}
function putXml(cfb, path, xml) {
  const e = CFB.find(cfb, path);
  if (!e) throw new Error('파일 안에 ' + path + ' 가 없습니다');
  const b = enc(xml);
  e.content = b;
  e.size = b.length;
}
function writeZip(cfb) {
  const out = CFB.write(cfb, { fileType: 'zip', type: 'array', compression: true });
  return out instanceof Uint8Array ? out : new Uint8Array(out);
}
// 시트 이름 → 압축 안 XML 경로 (workbook.xml r:id → workbook.xml.rels Target)
function sheetPath(cfb, sheetName) {
  const wbXml = getXml(cfb, '/xl/workbook.xml') || '';
  const rels = getXml(cfb, '/xl/_rels/workbook.xml.rels') || '';
  const esc = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const nameXml = String(sheetName).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const sm = wbXml.match(new RegExp('<sheet\\b[^>]*\\bname="' + esc(nameXml) + '"[^>]*>'));
  const rid = sm && (sm[0].match(/\br:id="([^"]+)"/) || [])[1];
  const rm = rid && rels.match(new RegExp('<Relationship\\b[^>]*\\bId="' + esc(rid) + '"[^>]*>'));
  const target = rm && (rm[0].match(/\bTarget="([^"]+)"/) || [])[1];
  if (!target) throw new Error('시트 경로를 찾지 못했습니다: ' + sheetName);
  return target.charAt(0) === '/' ? target : '/xl/' + target.replace(/^\.\//, '');
}
// 열면 다시 계산하게(밀크런 「구성 가능 수량」·박스 제목 수식). 캐시값도 직접 맞춰 두지만 엑셀이 다시 계산하는 게 정본
function forceRecalc(cfb) {
  const xml = getXml(cfb, '/xl/workbook.xml');
  if (!xml || /fullCalcOnLoad=/.test(xml)) return;
  const next = /<calcPr\b/.test(xml)
    ? xml.replace(/<calcPr\b/, '<calcPr fullCalcOnLoad="1"')
    : xml.replace(/<\/sheets>/, '</sheets><calcPr fullCalcOnLoad="1"/>');
  putXml(cfb, '/xl/workbook.xml', next);
}

const xmlEsc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// 공유 문자열(sharedStrings.xml) 표 — 같은 글자가 이미 있으면 그 번호, 없으면 끝에 붙인다
function makeSst(cfb) {
  const path = '/xl/sharedStrings.xml';
  let xml = getXml(cfb, path);
  if (xml == null) return null;
  const items = xml.match(/<si>[\s\S]*?<\/si>/g) || [];
  const plain = items.map(si => {
    const m = si.match(/^<si><t(?:\s[^>]*)?>([\s\S]*?)<\/t><\/si>$/);
    return m ? m[1] : null;
  });
  let added = 0;
  return {
    index(text) {
      const t = xmlEsc(text);
      const i = plain.indexOf(t);
      if (i >= 0) return i;
      plain.push(t);
      xml = xml.replace(/<\/sst>\s*$/, '<si><t>' + t + '</t></si></sst>');
      added++;
      return plain.length - 1;
    },
    save() {
      if (!added) return;
      xml = xml.replace(/<sst\b[^>]*>/, tag => tag
        .replace(/\bcount="(\d+)"/, (m, n) => 'count="' + (parseInt(n) + added) + '"')
        .replace(/\buniqueCount="(\d+)"/, (m, n) => 'uniqueCount="' + (parseInt(n) + added) + '"'));
      putXml(cfb, path, xml);
    }
  };
}

const colNum = ref => ref.replace(/\d+$/, '').split('').reduce((n, ch) => n * 26 + ch.charCodeAt(0) - 64, 0);
// 칸 하나 고치기. kind: 'n'(숫자) / 's'(공유문자열 번호) / 'cache'(수식은 두고 계산 결과 캐시만 — 문자열) / 'blank'(값 지움)
// 서식(s="..")은 원래 칸 것을 그대로 쓴다. 칸이 없으면 열 순서에 맞춰 끼워 넣는다(행은 있어야 한다)
function setCell(xml, ref, kind, value) {
  const cellRe = new RegExp('<c r="' + ref + '"([^>]*?)(/>|>([\\s\\S]*?)</c>)');
  const m = xml.match(cellRe);
  const attrs = m ? m[1].replace(/\s+t="[^"]*"/, '') : '';
  let body;
  if (kind === 'cache') {
    if (!m || !/<f[\s>]/.test(m[3] || '')) return xml; // 수식 칸이 아니면 손대지 않는다
    const f = (m[3].match(/<f[\s\S]*?(<\/f>|\/>)/) || [''])[0];
    body = '<c r="' + ref + '"' + attrs + ' t="str">' + f + '<v>' + xmlEsc(value) + '</v></c>';
    return xml.replace(cellRe, () => body);
  }
  if (kind === 'blank') {
    if (!m || !/<v>/.test(m[3] || '')) return xml; // 이미 빈칸
    return xml.replace(cellRe, () => '<c r="' + ref + '"' + attrs + '/>');
  }
  body = kind === 's'
    ? '<c r="' + ref + '"' + attrs + ' t="s"><v>' + value + '</v></c>'
    : '<c r="' + ref + '"' + attrs + '><v>' + value + '</v></c>';
  if (m) return xml.replace(cellRe, () => body);
  const rowNo = ref.match(/\d+$/)[0];
  const rowRe = new RegExp('<row r="' + rowNo + '"[^>]*?(/>|>([\\s\\S]*?)</row>)');
  const rm = xml.match(rowRe);
  if (!rm) throw new Error('행이 없습니다: ' + rowNo);
  if (rm[1] === '/>') return xml.replace(rowRe, rm[0].slice(0, -2) + '>' + body + '</row>');
  const cells = rm[2].match(/<c r="[A-Z]+\d+"[^>]*?(\/>|>[\s\S]*?<\/c>)/g) || [];
  const after = cells.find(c => colNum(c.match(/<c r="([A-Z]+)/)[1]) > colNum(ref));
  const inner = after ? rm[2].replace(after, () => body + after) : rm[2] + body;
  return xml.replace(rowRe, () => rm[0].replace(rm[2], () => inner));
}
// aoa(sheet_to_json header:1) 의 [행, 열] → 엑셀 칸 주소. 시트 범위가 A1 에서 시작하지 않아도 맞게 범위 시작점을 더한다
const refOf = ws => {
  const s = XLSX.utils.decode_range(ws['!ref'] || 'A1').s;
  return (r, c) => XLSX.utils.encode_cell({ r: r + s.r, c: c + s.c });
};

export function xlsxBlob(bytes) {
  return new Blob([bytes], { type: XLSX_MIME });
}

// ---------- ① 입고요청 엑셀 ----------
// qtyByBarcode: { 바코드: 수량 } (선택한 박스들 합). 반환:
//  filled  = 채운 행 [{ row, barcode, name, option, qty, prev }]
//  missing = 박스에는 있는데 파일에 없는 바코드 [{ barcode, qty }]
//  zeroed  = 파일에 원래 수량이 있었는데(윙 추천수량 등) 박스에 없어 0 으로 바꾼 행 [{ row, barcode, name, option, prev }]
//  dupes   = 파일에 같은 바코드가 두 번 이상 — 윙은 먼저 나온 행만 쓰므로 첫 행에만 넣고 나머지는 0
export function fillInboundRequest(buf, qtyByBarcode) {
  const { cfb, wb } = openZip(buf);
  const sheetName = wb.SheetNames.find(n => /로켓그로스\s*입고/.test(n)) || wb.SheetNames[0];
  const ws = wb.Sheets[sheetName];
  const ref = refOf(ws);
  const aoa = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', raw: true });
  // 제목 행 = 「입고 수량 입력」 과 「상품바코드」 가 같이 있는 행
  const norm = v => String(v).replace(/\s+/g, '');
  const hr = aoa.findIndex(r => r.some(v => norm(v).startsWith('입고수량입력')) && r.some(v => norm(v).startsWith('상품바코드')));
  if (hr < 0) throw new Error('「입고 수량 입력」 열을 찾지 못했습니다 — 윙 로켓그로스 입고요청 엑셀이 맞는지 확인해 주세요');
  const qCol = aoa[hr].findIndex(v => norm(v).startsWith('입고수량입력'));
  const bCol = aoa[hr].findIndex(v => norm(v).startsWith('상품바코드'));
  const nameCol = aoa[hr].findIndex(v => norm(v) === '등록상품명');
  const optCol = aoa[hr].findIndex(v => norm(v) === '옵션명');

  const want = {};
  Object.keys(qtyByBarcode || {}).forEach(k => { const q = parseInt(qtyByBarcode[k]) || 0; if (q > 0) want[normBarcode(k)] = (want[normBarcode(k)] || 0) + q; });
  const path = sheetPath(cfb, sheetName);
  let xml = getXml(cfb, path);
  const filled = [], zeroed = [], dupes = [], seen = {};
  for (let r = hr + 1; r < aoa.length; r++) {
    const row = aoa[r];
    if (String(row[0]).indexOf('예시') === 0) continue; // 「예시 및 설명」 행
    const bc = normBarcode(row[bCol]);
    if (!bc) continue;
    const prev = parseInt(row[qCol]) || 0;
    const info = { row: r + 1, barcode: bc, name: nameCol >= 0 ? row[nameCol] : '', option: optCol >= 0 ? row[optCol] : '', prev };
    let qty = 0;
    if (want[bc] && !seen[bc]) qty = want[bc];
    else if (want[bc]) dupes.push(info);
    seen[bc] = true;
    if (qty > 0) filled.push(Object.assign(info, { qty }));
    else if (prev > 0) zeroed.push(info);
    if (qty !== prev || String(row[qCol]) === '') xml = setCell(xml, ref(r, qCol), 'n', qty);
  }
  const missing = Object.keys(want).filter(bc => !seen[bc]).map(bc => ({ barcode: bc, qty: want[bc] }));
  putXml(cfb, path, xml);
  forceRecalc(cfb);
  return { bytes: writeZip(cfb), sheetName, filled, missing, zeroed, dupes, total: filled.reduce((s, f) => s + f.qty, 0) };
}

// ---------- ② 밀크런 박스 구성 ----------
// boxes: [{ labelId, size: '사이즈 3호'|'' , items: { 바코드: 수량 } }] — 넘긴 순서가 박스1, 박스2 … 순서다.
// 상품 종류·취급주의·지게차·수작업 상차는 손대지 않는다(원본값 유지, 2026-10-06 YZY).
// 반환: rows = 상품행 [{ row, barcode, total, assigned }], mismatch = 총수량 ≠ 박스 배정 합인 행,
//       missing = 박스에 있는데 이 시트에 없는 바코드, noSize = 사이즈를 못 정한 박스
export const MILKRUN_MAX_BOXES = 32;
export function fillMilkrun(buf, boxes) {
  const { cfb, wb } = openZip(buf);
  const n = boxes.length;
  if (!n) throw new Error('박스가 없습니다');
  if (n > MILKRUN_MAX_BOXES) throw new Error('밀크런 택배는 ' + MILKRUN_MAX_BOXES + '박스까지입니다(선택 ' + n + ')');
  const norm = v => String(v).replace(/\s+/g, '');
  const boxBarcodes = new Set();
  boxes.forEach(b => Object.keys(b.items || {}).forEach(k => boxBarcodes.add(normBarcode(k))));

  // 입고 시트(입고1, 입고2 …)가 여럿이면 선택 박스 바코드가 들어 있는 시트 하나만 채운다
  const sheets = wb.SheetNames.map(name => {
    const aoa = XLSX.utils.sheet_to_json(wb.Sheets[name], { header: 1, defval: '', raw: true });
    const hr = aoa.findIndex(r => r.some(v => norm(v) === '상품바코드') && r.some(v => norm(v) === '입고총수량'));
    const bc = hr >= 0 ? aoa[hr].findIndex(v => norm(v) === '상품바코드') : -1;
    const codes = hr >= 0 ? aoa.slice(hr + 2).map(r => normBarcode(r[bc])).filter(Boolean) : [];
    return { name, aoa, hr, codes, ref: refOf(wb.Sheets[name]), hit: codes.filter(c => boxBarcodes.has(c)).length };
  }).filter(s => s.hr >= 0);
  if (!sheets.length) throw new Error('「상품바코드 / 입고 총 수량」 표를 찾지 못했습니다 — 윙 Milkrun_Configuration 파일이 맞는지 확인해 주세요');
  const hits = sheets.filter(s => s.hit > 0);
  if (hits.length > 1) throw new Error('이 파일에 입고가 여러 개(' + hits.map(s => s.name).join(', ') + ') 있습니다 — 입고별로 박스를 나눠 한 번씩 처리해 주세요');
  const sh = hits[0] || sheets[0];
  const { aoa, hr, ref } = sh;
  const H = aoa[hr];
  const bCol = H.findIndex(v => norm(v) === '상품바코드');
  const tCol = H.findIndex(v => norm(v) === '입고총수량');
  const gCol = H.findIndex(v => norm(v) === '구성가능수량');
  const box0 = (gCol >= 0 ? gCol : tCol) + 1; // 박스1 열 = 「구성 가능 수량」 다음 칸
  // 헤더 블록 값 칸 = 라벨 오른쪽 칸
  const findLabel = label => {
    for (let r = 0; r < hr; r++) {
      const c = aoa[r].findIndex(v => norm(v) === norm(label));
      if (c >= 0) return { r, c: c + 1 };
    }
    return null;
  };
  // 시트 머리 안내문 「물류센터: 안성5 / 물류센터 도착예정일: 19000101」 — 입고센터·입고예정일 기본값(화면에서 고칠 수 있다).
  // 도착예정일이 19000101 이면 아직 안 정해진 값이라 버린다
  let center = '', arriveDate = '';
  for (let r = 0; r < hr; r++) {
    aoa[r].forEach(v => {
      const t = String(v);
      const cm = t.match(/물류센터\s*:\s*([^\r\n]+)/);
      if (cm && !center) center = cm[1].trim();
      const dm = t.match(/도착예정일\s*:\s*(\d{4})(\d{2})(\d{2})/);
      if (dm && !arriveDate && dm[1] !== '1900') arriveDate = dm[1] + '-' + dm[2] + '-' + dm[3];
    });
  }
  const cntAt = findLabel('박스 총 수량(개)');
  const wtAt = findLabel('총 중량(kg)');
  if (!cntAt || !wtAt) throw new Error('「박스 총 수량 / 총 중량」 칸을 찾지 못했습니다');

  const path = sheetPath(cfb, sh.name);
  let xml = getXml(cfb, path);
  const sst = makeSst(cfb);
  if (!sst) throw new Error('sharedStrings.xml 이 없습니다');
  xml = setCell(xml, ref(cntAt.r, cntAt.c), 'n', n);
  const weight = milkrunWeight(n);
  xml = setCell(xml, ref(wtAt.r, wtAt.c), 'n', weight);

  // 박스 제목(수식 IF(I5>=k,"박스k","")) 캐시값과 사이즈 행
  const noSize = [];
  for (let k = 0; k < MILKRUN_MAX_BOXES; k++) {
    const c = box0 + k;
    xml = setCell(xml, ref(hr, c), 'cache', k < n ? '박스' + (k + 1) : '');
    if (k < n) {
      if (boxes[k].size) xml = setCell(xml, ref(hr + 1, c), 's', sst.index(boxes[k].size));
      else noSize.push(boxes[k].labelId);
    }
  }
  // 상품행: 박스별 수량. 그 박스에 없는 상품 칸은 빈칸(윙이 준 원본처럼) — 이미 채운 파일을 다시 올려도 옛 숫자가 남지 않게 32칸 전부 본다
  const rows = [], mismatch = [], seen = {};
  for (let r = hr + 2; r < aoa.length; r++) {
    const bc = normBarcode(aoa[r][bCol]);
    if (!bc) continue;
    seen[bc] = true;
    let assigned = 0;
    for (let k = 0; k < MILKRUN_MAX_BOXES; k++) {
      const items = (k < n && boxes[k].items) || {};
      const q = Object.keys(items).filter(x => normBarcode(x) === bc).reduce((s, x) => s + (parseInt(items[x]) || 0), 0);
      if (q > 0) {
        xml = setCell(xml, ref(r, box0 + k), 'n', q);
        assigned += q;
      } else {
        xml = setCell(xml, ref(r, box0 + k), 'blank');
      }
    }
    const total = parseInt(aoa[r][tCol]) || 0;
    if (gCol >= 0) {
      const g = aoa[r][gCol];
      if (g !== '' && g != null) xml = setCellCacheNum(xml, ref(r, gCol), total - assigned);
    }
    const info = { row: r + 1, barcode: bc, name: aoa[r][0] || '', option: aoa[r][1] || '', total, assigned };
    rows.push(info);
    if (total !== assigned) mismatch.push(info);
  }
  const missing = [...boxBarcodes].filter(bc => !seen[bc]).map(bc => ({
    barcode: bc,
    qty: boxes.reduce((s, b) => s + Object.keys(b.items || {}).filter(x => normBarcode(x) === bc).reduce((t, x) => t + (parseInt(b.items[x]) || 0), 0), 0)
  }));
  sst.save();
  putXml(cfb, path, xml);
  forceRecalc(cfb);
  return { bytes: writeZip(cfb), sheetName: sh.name, boxCount: n, weight, rows, mismatch, missing, noSize, center, arriveDate };
}
// 숫자 수식 칸(구성 가능 수량 =F-SUM(..))의 캐시값만 바꾼다
function setCellCacheNum(xml, cellRef, num) {
  const cellRe = new RegExp('<c r="' + cellRef + '"([^>]*?)>([\\s\\S]*?)</c>');
  const m = xml.match(cellRe);
  if (!m || !/<f[\s>]/.test(m[2])) return xml;
  const f = (m[2].match(/<f[\s\S]*?(<\/f>|\/>)/) || [''])[0];
  return xml.replace(cellRe, () => '<c r="' + cellRef + '"' + m[1].replace(/\s+t="[^"]*"/, '') + '>' + f + '<v>' + num + '</v></c>');
}
